// extracted by mini-css-extract-plugin
export var backdropBlur = "_lg-0";